module.exports = __webpack_public_path__ + "static/media/Banner5.cf7f350f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/Banner5.jpg
// module id = 578
// module chunks = 0